module.exports = __webpack_public_path__ + "static/media/LTCUSDT.83c80dd5.png";